module.exports = __webpack_public_path__ + "media/images/lb/714-1ffdf6dab281aabd96d1fbf2f2f6b03a.svg";